import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditServicestextFour = () => {
    const [servicetext, setService] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/service-four/${id}`)
            .then((res) => res.json())
            .then((info) => setService(info));
    }, [id]);

    const handleServiceText = (event) => {
        event.preventDefault();
        const servicesubHeadingFour = event.target.servicesubHeadingFour.value;
        const serviceHeadingFour = event.target.serviceHeadingFour.value;

        const serviceSection = {
            servicesubHeadingFour,
            serviceHeadingFour,
        };

        const url = `https://ai-automation-audit-01-e0855711738d.herokuapp.com/service-four/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(serviceSection),
        })
            .then((res) => res.json())
            .then((result) => {
                alert('Service Text is Updated');
            });
    };

    return (
        <>
           
            <section id="services" className="services-area vh-100 d-flex align-items-center">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-12">
                            <h2 className="text-center mb-4">Update Service Text</h2>
                            <form
                                className="contact-form d-flex flex-column align-items-center"
                                onSubmit={handleServiceText}
                            >
                                <div className="form-group w-100 mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="serviceHeadingFour"
                                        defaultValue={servicetext.serviceHeadingFour}
                                        placeholder="Service Heading"
                                        required
                                    />
                                </div>
                                <div className="form-group w-100 mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="servicesubHeadingFour"
                                        defaultValue={servicetext.servicesubHeadingFour}
                                        placeholder="Service Sub Heading"
                                        required
                                    />
                                </div>
                                <div className="slider-btn">
                                    <button
                                        className="theme-btn btn-one btn btn-primary"
                                        data-animation="fadeInRight"
                                        data-delay=".8s"
                                    >
                                        Update Services Text
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EditServicestextFour;
